var map = {
	"./ae.png": 80,
	"./at.png": 81,
	"./balloon.png": 82,
	"./bt.png": 83,
	"./copyright.png": 84,
	"./cursive.png": 85,
	"./doublek.png": 86,
	"./dragon.png": 87,
	"./euro.png": 88,
	"./filledstar.png": 89,
	"./hollowstar.png": 90,
	"./hookn.png": 91,
	"./leftc.png": 92,
	"./meltedthree.png": 93,
	"./nwithhat.png": 94,
	"./omega.png": 95,
	"./paragraph.png": 96,
	"./pitchfork.png": 97,
	"./pumpkin.png": 98,
	"./questionmark.png": 99,
	"./rightc.png": 100,
	"./six.png": 101,
	"./smileyface.png": 102,
	"./squidknife.png": 103,
	"./squigglyn.png": 104,
	"./tracks.png": 105,
	"./upsidedowny.png": 106
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79;